module.exports = __webpack_public_path__ + "img/109048.d039dad2.png";